/**
 * @file GENERATED by `npm run sfx` (`tools/build-sfx.mjs`). DO NOT EDIT.
 *
 * Attribution for every sound the game ships, keyed to the SHIPPED filename
 * rather than the raw pack's. It is generated from the same pass that does the
 * renaming, so the two cannot drift: a credit here names a file in
 * `public/audio/`, and every file in `public/audio/` has a row here (the
 * build throws otherwise).
 *
 * ⚠ MOST OF THIS IS CC0, WHICH DOES NOT LEGALLY REQUIRE CREDIT. ONE CLIP IS NOT.
 * `wood_collision` v3 (zimbot) is **CC BY 4.0** and its attribution is a
 * LICENCE CONDITION, not a courtesy — if the credits screen is ever trimmed,
 * that row is the one that may not go. `requiresAttribution` marks it.
 */

/** @typedef {{files: string[], slug: string, title: string, author: string, url: string, license: string, licenseUrl: string, requiresAttribution: boolean}} CreditEntry */

/** @type {CreditEntry[]} */
export const SFX_CREDITS = [
  {
    files: ["gunshot_1.mp3", "gunshot_2.mp3", "gunshot_3.mp3"],
    slug: "gunshot",
    title: "9mm Pistol Gunshots",
    author: "DledeSOUND",
    url: "https://freesound.org/s/731942/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["groan_1.mp3", "groan_2.mp3", "groan_3.mp3"],
    slug: "groan",
    title: "Soft Male Vocal, Short Pained/Exhertion Groans - Vocal Efforts",
    author: "salemaudio",
    url: "https://freesound.org/s/803168/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["footstep_1.mp3", "footstep_2.mp3", "footstep_3.mp3", "footstep_4.mp3", "footstep_5.mp3", "footstep_6.mp3"],
    slug: "footstep",
    title: "male footsteps on wooden floor 1",
    author: "FOSSarts",
    url: "https://freesound.org/people/FOSSarts/sounds/740292/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["footstep_7.mp3", "footstep_8.mp3", "footstep_9.mp3", "footstep_10.mp3", "footstep_11.mp3"],
    slug: "footstep",
    title: "male heavy footsteps on wooden floor 1",
    author: "FOSSarts",
    url: "https://freesound.org/people/FOSSarts/sounds/740293/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["footstep_12.mp3", "footstep_13.mp3", "footstep_14.mp3", "footstep_15.mp3", "footstep_16.mp3"],
    slug: "footstep",
    title: "Footsteps",
    author: "artemditkovsky",
    url: "https://freesound.org/people/artemditkovsky/sounds/856942/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["car_crash_1.mp3"],
    slug: "car_crash",
    title: "Car Crash_EXT.wav",
    author: "PauliusI",
    url: "https://freesound.org/s/346299/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["car_crash_2.mp3"],
    slug: "car_crash",
    title: "crashing.wav",
    author: "smmassuda",
    url: "https://freesound.org/s/136629/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["car_start_1.mp3"],
    slug: "car_start",
    title: "Key Ignition",
    author: "microman502",
    url: "https://freesound.org/s/818297/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["car_start_2.mp3"],
    slug: "car_start",
    title: "Car Startup (Engine Ignition)",
    author: "magnuswaker",
    url: "https://freesound.org/s/581082/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["car_start_3.mp3"],
    slug: "car_start",
    title: "Car start 1.wav",
    author: "spurioustransients",
    url: "https://freesound.org/s/534924/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["car_engine_1.mp3"],
    slug: "car_engine",
    title: "Vehicle_Car_Peugeot_308_Idle_Exterior_Loop_Mono_01.wav",
    author: "Nox_Sound",
    url: "https://freesound.org/s/522218/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["siren_police_1.mp3"],
    slug: "siren_police",
    title: "SS2000_wail_seamless",
    author: "ThePeasantJoe",
    url: "https://freesound.org/people/ThePeasantJoe/sounds/800708/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["siren_police_2.mp3"],
    slug: "siren_police",
    title: "police3.wav",
    author: "guitarguy1985",
    url: "https://freesound.org/people/guitarguy1985/sounds/70939/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["siren_ambulance_1.mp3"],
    slug: "siren_ambulance",
    title: "German Ambulance.wav",
    author: "Breviceps",
    url: "https://freesound.org/people/Breviceps/sounds/468098/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["siren_ambulance_2.mp3"],
    slug: "siren_ambulance",
    title: "Ambulance",
    author: "sofialomba",
    url: "https://freesound.org/people/sofialomba/sounds/469413/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["prop_smash_1.mp3"],
    slug: "prop_smash",
    title: "Crate Break 2.wav",
    author: "kevinkace",
    url: "https://freesound.org/s/66778/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["prop_smash_2.mp3"],
    slug: "prop_smash",
    title: "Crate Break 4.wav",
    author: "kevinkace",
    url: "https://freesound.org/s/66780/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["prop_smash_3.mp3"],
    slug: "prop_smash",
    title: "WoodSmashAndFall_04.wav",
    author: "zimbot",
    url: "https://freesound.org/s/89391/",
    license: "CC BY 4.0",
    licenseUrl: "https://creativecommons.org/licenses/by/4.0/",
    requiresAttribution: true,
  },
  {
    files: ["door_1.mp3"],
    slug: "door",
    title: "Door (Opening and Closing)",
    author: "Breviceps",
    url: "https://freesound.org/people/Breviceps/sounds/457042/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["door_2.mp3", "door_3.mp3"],
    slug: "door",
    title: "Interrior wooden door metal handle opening and closing (multi-take)",
    author: "Sadiquecat",
    url: "https://freesound.org/people/Sadiquecat/sounds/801839/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["rain_1.mp3"],
    slug: "rain",
    title: "Soft Rain Loop",
    author: "_lynks",
    url: "https://freesound.org/people/_lynks/sounds/595717/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["rain_2.mp3"],
    slug: "rain",
    title: "Looping Rain On Skylight Foley Texture",
    author: "deadrobotmusic",
    url: "https://freesound.org/people/deadrobotmusic/sounds/663947/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["drone_1.mp3"],
    slug: "drone",
    title: "Mini Quadcopter Flying Loop",
    author: "simeonradivoev",
    url: "https://freesound.org/s/383852/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["phone_ring_1.mp3"],
    slug: "phone_ring",
    title: "Ringtone: Kitchen phone (take 2)",
    author: "knufds",
    url: "https://freesound.org/s/345810/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["phone_ring_2.mp3"],
    slug: "phone_ring",
    title: "Stromberg Carlson 1543.wav",
    author: "Hockinfinger",
    url: "https://freesound.org/s/274436/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["phone_key_1.mp3", "phone_key_2.mp3", "phone_key_3.mp3"],
    slug: "phone_key",
    title: "phone tones",
    author: "ImATaco",
    url: "https://freesound.org/s/827200/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["cash_1.mp3"],
    slug: "cash",
    title: "Cash Register Fake.wav",
    author: "CapsLok",
    url: "https://freesound.org/s/184438/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["cash_2.mp3"],
    slug: "cash",
    title: "cash register old antique open close drawer with bell ring various combinations.wav",
    author: "kyles",
    url: "https://freesound.org/s/452572/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["text_notify_1.mp3"],
    slug: "text_notify",
    title: "Notification Sound",
    author: "yfjesse",
    url: "https://freesound.org/s/235911/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
  {
    files: ["ui_notify_1.mp3"],
    slug: "ui_notify",
    title: "Notification Sound 1",
    author: "deadrobotmusic",
    url: "https://freesound.org/s/750607/",
    license: "CC0 1.0",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    requiresAttribution: false,
  },
];

/** Distinct licences in the shipped set, for the credits screen's summary line. */
export const SFX_LICENSES = Object.freeze([
  "CC0 1.0",
  "CC BY 4.0",
]);

/** Where the pack came from, stated once. */
export const SFX_SOURCE = Object.freeze({
  site: 'Freesound',
  url: 'https://freesound.org/',
  note: 'Processed for this game: trimmed, downmixed to 44.1 kHz mono, peak-normalised per source recording, encoded as MP3.',
});
